import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from "styled-components";
import { DEFAULT_THEME } from "./utils/consts";
var UiKitTheme = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? DEFAULT_THEME : _b, children = _a.children;
    return _jsx(ThemeProvider, { theme: theme, children: children });
};
export default UiKitTheme;
//# sourceMappingURL=UiKitTheme.js.map